import { render, staticRenderFns } from "./run-workflow.vue?vue&type=template&id=c2b944c6&scoped=true"
import script from "./run-workflow.vue?vue&type=script&lang=js"
export * from "./run-workflow.vue?vue&type=script&lang=js"
import style0 from "./run-workflow.vue?vue&type=style&index=0&id=c2b944c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b944c6",
  null
  
)

export default component.exports